var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRating5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#44db62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#197d2c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 1,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9183",
    "data-name": "Group 9183",
    transform: "translate(-3625 -10364)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_443",
    "data-name": "Ellipse 443",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(3625 10364)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_448",
    "data-name": "Ellipse 448",
    cx: 34,
    cy: 34,
    r: 34,
    transform: "translate(3628 10367)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9175",
    "data-name": "Group 9175",
    transform: "translate(3641.65 10390.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8894",
    "data-name": "Path 8894",
    d: "M1698.459,38.356a.659.659,0,0,1-.719.053c-5.482-3.02-11.407-1.48-12.693-1.231a.672.672,0,0,1-.125.012.654.654,0,0,1-.589-.373c-.163-.338.046-.652.338-.888.943-.761,7.084-5.9,13.872,1.443a.667.667,0,0,1-.085.983",
    transform: "translate(-1684.276 -33.471)",
    fill: "#0c3a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8895",
    "data-name": "Path 8895",
    d: "M1829.223,38.356a.66.66,0,0,0,.719.053c5.482-3.02,11.406-1.48,12.692-1.231a.673.673,0,0,0,.125.012.654.654,0,0,0,.589-.373c.163-.338-.045-.652-.338-.888-.943-.761-7.084-5.9-13.872,1.443a.667.667,0,0,0,.085.983",
    transform: "translate(-1802.413 -33.471)",
    fill: "#0c3a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8896",
    "data-name": "Path 8896",
    d: "M1728.869,126.309s2,8.927,12.314,8.927a12.232,12.232,0,0,0,12.314-8.927Z",
    transform: "translate(-1720.687 -109.274)",
    fill: "#0c3a21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating5);
export default __webpack_public_path__ + "static/media/rating_5.c93ce37b14367c5e52c1cfeb843e63e6.svg";
export { ForwardRef as ReactComponent };